<template>
<div>
  <div slot="header" class="clearfix" style="text-align: center;">
    <Input v-model="queryStr" placeholder="请输入关键词" @on-change="fetchData" style="width:320px;"></Input>&nbsp;
    <Button type="primary" @click="exportDiffs">
      <Icon type="ios-cloud-download" /> 导出比对记录
    </Button>&nbsp;
    <Button type="success" @click="compare">
      <Icon type="ios-play" /> 重新比对
    </Button>
  </div>
  <Table :loading="loading" stripe :columns="attributes" :data="diffs" v-if="diffs" ref="table">
    <template slot-scope="{ row }" slot="subject">
      <div class="">{{ row.subjid }}</div>
    </template>
    <template slot-scope="{ row }" slot="variable">
      <div class="">{{ row.visitName }}</div>
      <div class="">{{ row.domainName }}</div>
      <div class="">{{ row.varName }}</div>
    </template>
  </Table>
  <pagination v-bind:meta="pageMeta" name="pagination"
  v-if="pageMeta.pageCount > 1" @refresh="fetchData"></pagination>

  <Spin size="large" fix v-if="spinShow">
    <Icon type="load-c" size="18"></Icon>
    <div>
      数据导出中……，<br /><br />可能需要几十秒到十几分钟不等，请耐心等待……
    </div>
  </Spin>
</div>
</template>

<script>
import Pagination from '@/components/share/Pagination'
import { ListDiffs, DoCompare, ExportDiffs } from '@/api/diff'

export default {
  name: 'list-diffs',
  data: function () {
    return {
      diffs: [],
      pageMeta: {},
      queryStr: '',
      loading: true,
      spinShow: false,
      attributes: [
        { title: '研究中心', key: 'siteName' },
        { title: '受试者', key: 'subjid' },
        { title: '访视', key: 'visitName' },
        { title: '数据表', key: 'domainName' },
        { title: '变量', key: 'varName' },
        { title: '初录值', key: 'first' },
        { title: '二录值', key: 'second' }
      ]
    }
  },
  components: {
    'pagination': Pagination
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function ($page = 1) {
      var query = {}
      query['page'] = $page
      query['queryStr'] = this.queryStr
      query['DiffSearch[studyid]'] = this.$route.params.id
      ListDiffs(query).then(async res => {
        this.diffs = res.items
        this.pageMeta = res._meta
        this.loading = false
      })
    },
    exportDiffs: function () {
      this.spinShow = true
      ExportDiffs(this.$route.params.id).then(async res => {
        this.$Message.success('导出成功')
        this.spinShow = false
        const filetype = 'text/csv'
        this.export(res, filetype, '双录入一致性比对记录.csv')
      })
    },
    export: function (res, type, filename) {
      let blob = new Blob([res], { type: type })
      var link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      window.URL.revokeObjectURL(link.href)
      this.loading = false
    },
    compare: function () {
      this.loading = true
      DoCompare().then(async res => {
        this.fetchData()
      })
    }
  }
}
</script>
